import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// Vuetify
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

import VueGoogleMaps from "@fawmi/vue-google-maps";

const vuetify = createVuetify({
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
  components,
  directives,
});

import VueI18n from "vue-i18n";
import i18n from "./i18n";
// import bootstrap
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "normalize.css";
// import bootstrap vue
// import { BootstrapVue } from 'bootstrap-vue'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

const options = {
  confirmButtonColor: "#41b882",
  cancelButtonColor: "#ff7674",
  timer: 2000,
};

// import fontawesome
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
library.add(fas, far, fab);
dom.watch();

// import axios
import axios from "axios";
axios.defaults.baseURL = "https://backend.saqf-sa.com/api";
// axios.defaults.headers.common['Authorization'] = localStorage.getItem('token');
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.lang = localStorage.getItem("lang");

// Global response interceptor to handle needActive and blocked responses
axios.interceptors.response.use(
  (response) => {
    // Check if response contains needActive key
    if (response.data && response.data.key === "needActive") {
      // Store phone and country_code if they exist in the response
      if (response.data.data && response.data.data.phone) {
        localStorage.setItem("phone", response.data.data.phone);
      }
      if (response.data.data && response.data.data.country_code) {
        localStorage.setItem("country_code", response.data.data.country_code);
      }
      
      // Store the message for later use
      localStorage.setItem("needActiveMessage", response.data.msg);
      
      // Redirect to keyCode page
      window.location.href = "/keyCode";
      return Promise.reject(response); // Reject to prevent further processing
    }
    
    // Check if response contains blocked key
    if (response.data && response.data.key === "blocked") {
      // Store the message for later use
      localStorage.setItem("blockedMessage", response.data.msg);
      
      // Clear user session data
      localStorage.removeItem("token");
      localStorage.removeItem("userName");
      localStorage.removeItem("userImage");
      localStorage.removeItem("visitorId");
      
      // Store the message and redirect info for the router to handle
      localStorage.setItem("redirectToLogin", "true");
      
      // Redirect to login page
      window.location.href = "/loginView";
      return Promise.reject(response); // Reject to prevent further processing
    }
    
    return response;
  },
  (error) => {
    // Handle error responses
    if (error.response && error.response.data && error.response.data.key === "needActive") {
      // Store phone and country_code if they exist in the error response
      if (error.response.data.data && error.response.data.data.phone) {
        localStorage.setItem("phone", error.response.data.data.phone);
      }
      if (error.response.data.data && error.response.data.data.country_code) {
        localStorage.setItem("country_code", error.response.data.data.country_code);
      }
      
      // Store the message for later use
      localStorage.setItem("needActiveMessage", error.response.data.msg);
      
      // Redirect to keyCode page
      window.location.href = "/keyCode";
    }
    
    // Handle error responses for blocked
    if (error.response && error.response.data && error.response.data.key === "blocked") {
      // Store the message for later use
      localStorage.setItem("blockedMessage", error.response.data.msg);
      
      // Clear user session data
      localStorage.removeItem("token");
      localStorage.removeItem("userName");
      localStorage.removeItem("userImage");
      localStorage.removeItem("visitorId");
      
      // Store the message and redirect info for the router to handle
      localStorage.setItem("redirectToLogin", "true");
      
      // Redirect to login page
      window.location.href = "/loginView";
    }
    
    return Promise.reject(error);
  }
);

// primevue
//theme
import "primevue/resources/themes/lara-light-indigo/theme.css";

//core
import "primevue/resources/primevue.min.css";

import PrimeVue from "primevue/config";

import GoogleMap from "vue-google-maps-ui";

import ToastService from 'primevue/toastservice';

createApp(App)
  .use(store)
  .use(vuetify)
  .use(ToastService)
  .use(PrimeVue)
  .use(GoogleMap)
  .use(VueGoogleMaps, {
    load: {
      key: "AIzaSyBNLoYGrbnQI_GMqHt6m0PSN9yA7Zvq7gA",
      // language: 'de',
    },
  })
  .use(router)
  .use(VueI18n)
  .use(i18n)
  .use(VueSweetalert2, options)
  .component("font-awesome-icon", FontAwesomeIcon)
  .mount("#app");
